import PropTypes from 'prop-types';
import React from 'react';
import { ONE_SECOND, THREE_SECONDS } from '../../constants/time';

export default class SecondsTimer extends React.Component {
    constructor(props) {
        super(props);
        this.updateSecondsElapsed = this.updateSecondsElapsed.bind(this);
        this.state = {
            secondsElapsed: 0,
        };
    }

    componentDidMount() {
        this.startTimer();
    }

    componentDidUpdate(prevProps) {
        if (!this.props.isTimerActive
            && prevProps.isTimerActive !== this.props.isTimerActive) {
            clearInterval(this.interval);
            this.updateSecondsElapsed(0);
            this.startTimer();
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    updateSecondsElapsed = seconds => {
        this.setState({ secondsElapsed: seconds });
    }

    getStyles(index) {
        return `seconds-timer-cell${this.state.secondsElapsed > index ? ' active' : ''}`;
    }

    startTimer() {
        this.props.activateTimer();
        this.interval = setInterval(() => {
            if (this.state.secondsElapsed < this.props.seconds) {
                this.setState(prevState => ({ secondsElapsed: prevState.secondsElapsed + 1}));
            }
        }, ONE_SECOND);
    }

    render() {
        return (
            <div className="seconds-timer-container">
                {
                    [...Array(this.props.seconds)].map((x, i) => (<div key={`second-${i + 1}`} className={this.getStyles(i)} />))
                }
            </div>
        );
    }
}

SecondsTimer.propTypes = {
    seconds: PropTypes.number,
    isTimerActive: PropTypes.bool,
    activateTimer: PropTypes.func,
};

SecondsTimer.defaultProps = {
    seconds: THREE_SECONDS,
    isTimerActive: true,
    activateTimer: () => {},
};
